import { isLightOrDark } from '../../services/lightOrDark';

const useTextColor = (color: string) => (isLightOrDark(color) === 'light' ? '#343a40' : '#fff');

export { useTextColor };
